import { useQuery } from "react-query";

import { searchService } from "services";

type UseApplicationSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useApplicationSearchQuery = ({
	pattern,
	page,
	options,
}: UseApplicationSearchQueryProps) =>
	useQuery(
		["applicationSearch", pattern, page],
		() =>
			searchService.getApplications({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useApplicationSearchQuery;
